import { useEffect, useState } from "react";
import axios from "axios";
import { FinanceData } from "../types/FinanceData";

export enum Status {
    Loading,
    Error,
    Success,
}

export const FetchData = () => {
    const [data, setdata] = useState<FinanceData | null>(null);
    const [status, setStatus] = useState<Status>(Status.Loading);

    useEffect(() => {
        async function callEndpoint() {
            try {
                const data = await axios.get<FinanceData>("https://api.saneetbhella.co.uk/finance/data");
                setdata(data.data);
                setStatus(Status.Success);
            } catch (err: any) {
                console.log(err);
                setStatus(Status.Error);
            }
        }
        callEndpoint();
    }, []);

    return { data, status };
};
